import { UnwrapHelper } from './UnwrapHelper';
export class UnwrapCopyStructHelper extends UnwrapHelper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitPushInt(node, 1);
        sb.emitOp(node, 'PICKITEM');
        sb.emitOp(node, 'VALUES');
        sb.emitOp(node, 'NEWSTRUCT');
    }
}

//# sourceMappingURL=UnwrapCopyStructHelper.js.map
